module.exports = __webpack_public_path__ + "site/img/wazh.37a1f69e.png";